/*
 * @Author: Tina Huang
 * @Date: 2024-02-18 17:54:20
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:49:04
 * @Description:
 */
import { Card, Tooltip } from 'antd'
import { CopyrightCircleOutlined, EditOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

export default function LibItem(props: { item: any }) {
  const { item } = props
  const navigate = useNavigate()

  const handleClick = () => {
    if (item?.extra_link) {
      return window.open(item.extra_link)
    }
    // window?.splitbee.track('Select widget', {
    //   type: item.tag,
    //   id: item.id,
    // })
    navigate(`/libs/${item.id}`)
  }

  return (
    <Card
      hoverable
      style={{ width: 300, marginTop: 16 }}
      cover={item?.cover && <img alt="example" src={item?.cover} />}
      onClick={handleClick}
      actions={[
        <Tooltip title="阿汪同学原创">
          <CopyrightCircleOutlined key="copyright" />
        </Tooltip>,

        <Tooltip title="去配置组件">
          {/* <Button type="primary" shape="round" icon={<EditOutlined />} onClick={handleClick}>
            去创建
          </Button> */}
          <EditOutlined key="edit" onClick={handleClick} />
        </Tooltip>,
        // <Tooltip title="直接拷贝组件链接">
        //   <CopyOutlined key="copy" />
        // </Tooltip>,
      ]}
    >
      <Card.Meta title={item?.tag} description={item?.desc} />
    </Card>
  )
}
